// extracted by mini-css-extract-plugin
export var page = "pageLikes-module--page--lpSef";
export var d1 = "pageLikes-module--d1--Vw8YI";
export var flexTop = "pageLikes-module--flexTop--NFrSV";
export var postReads = "pageLikes-module--postReads--BiF+Q";
export var likes = "pageLikes-module--likes--Rd9hZ";
export var d2 = "pageLikes-module--d2--pyw1f";